import React, { useState } from "react";
import NotificationPreference from "features/notifications/notificationPreference";
import notificationService from "features/notifications/notificationService";
import commonNotificationService from "common/notificationService";
import { Producer } from "./producer";
import "./ProducerNotificationPreferences.scss";
import ConfirmationModal, { useConfirmationModal } from "common/ui/ConfirmationModal";
import ProducerNotificationModal from "./ProducerNotificationModal";
import useStartup from "common/ui/useStartup";
import _ from "lodash";
import { useSelector } from "react-redux";
import IAppStore from "app/IAppStore";
import producerService from "./producerService";

export type ProducerNotificationPreferencesProps = {
    producer: Producer;
    handleClose: () => void;
};

const ProducerNotificationPreferences: React.FC<ProducerNotificationPreferencesProps> = (props: ProducerNotificationPreferencesProps) => {
    const [preferences, setPreferences] = useState<NotificationPreference[]>(null);
    const [showNotificationModal, setShowNotificationModal] = useState(true);
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);
    const [producer, setProducer] = useState<Producer>(props.producer);

    const confirmModal = useConfirmationModal();

    useStartup(() => {   
        getPreferences();
        if(isCustomer)
        {
            producerService.getCustomerInfo().then(result => setProducer(result));
        }
    });

    function getPreferences() {
        if(isCustomer)
        {
            notificationService.listPreferences()
            .then(prefs => setPreferences(_.sortBy(prefs, m => m.displayOrder)));
        }
        else
        {
            notificationService.listPreferencesForCustomer(producer.id)
                .then(prefs => {                
                    setPreferences(_.sortBy(prefs, m => m.displayOrder));
                });
        }
    }

    function enableRuleAgain(preference: NotificationPreference) {
        setShowNotificationModal(false);
        
        confirmModal.show(
            "Re-enable notification?",
            `${isCustomer ? 'You have' : 'Customer has'} unsubscribed the notification. Do you want to enable the notification again?`,
            () => { updateRule(preference); setShowNotificationModal(true)},
            () => setShowNotificationModal(true)
        );
    } 

    function updateRule(preference: NotificationPreference): void {
        
        try {    
            setPreferences(preferences.map(m => m.notificationType === preference.notificationType
                ? preference
                : m));     
            if(isCustomer)
            {
                notificationService.updatePreference(preference).then(() => {
                    getPreferences();
                });
            }   
            else
            {
                notificationService.updatePreferenceForCustomer(producer.id, preference).then(() => {
                    getPreferences();
                });
            }
        }
        catch  {
            props.handleClose();
            commonNotificationService.error("Error updating the notification");
        }
    }

    function onRuleChange(preference: NotificationPreference, isReEnabled: boolean): void { 
        if(isReEnabled)
            enableRuleAgain(preference);        
        else
            updateRule(preference);
    }

    if(preferences == null) return <></>;

    return <>
        {producer != null && showNotificationModal && <ProducerNotificationModal 
            preferences={preferences}
            isEmailNotSet={!producer.email || producer.email.trim().length === 0}
            isPhoneNotSet={!producer.phone || producer.phone.trim().length === 0}
            onRuleChange={onRuleChange}
            handleClose={props.handleClose}
            producer={producer}
            />}
        {!showNotificationModal && <ConfirmationModal modalState={confirmModal.state} />}
    </>
}
  

export default ProducerNotificationPreferences;